import { ELoginIssueType } from '../../types/loginIssueType';
export var LOGIN_ISSUE_TYPE_ANSWERS = [{
  label: 'Изменился номер телефона',
  value: ELoginIssueType.ChangedPhone
}, {
  label: 'Другой вопрос про вход на сайт',
  value: ELoginIssueType.AnotherQuestion
}];